module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inteChangeDet"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("奖品详情\n        "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('el-form', {
    ref: "inteForm",
    attrs: {
      "model": _vm.inteForm,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "替换序号:",
      "prop": "position",
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.inteForm.position),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "position", $$v)
      },
      expression: "inteForm.position"
    }
  }, _vm._l((8), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": index + 1,
        "value": index + 1
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖品名称：",
      "required": ""
    }
  }, [_c('el-input', {
    staticClass: "inputTitle",
    attrs: {
      "placeholder": "奖品名称",
      "disabled": ""
    },
    model: {
      value: (_vm.inteForm.prizeName),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "prizeName", $$v)
      },
      expression: "inteForm.prizeName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖品图片：",
      "required": ""
    }
  }, [_c('img', {
    staticStyle: {
      "width": "200px",
      "display": "inline-block"
    },
    attrs: {
      "src": _vm.inteForm.imgUrl
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("（尺寸说明：360×300像素，jpg、jpeg、png）")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "可中奖次数:",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0",
      "disabled": ""
    },
    model: {
      value: (_vm.inteForm.isLimit),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "isLimit", $$v)
      },
      expression: "inteForm.isLimit"
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('el-radio', {
    staticClass: "inline",
    attrs: {
      "label": "1",
      "disabled": ""
    },
    model: {
      value: (_vm.inteForm.isLimit),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "isLimit", $$v)
      },
      expression: "inteForm.isLimit"
    }
  }, [_vm._v("限定")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.inteForm.isLimit == "1") ? _c('el-input', {
    staticClass: "probability",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入自定义数量",
      "disabled": ""
    },
    model: {
      value: (_vm.inteForm.drawHitCount),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "drawHitCount", $$v)
      },
      expression: "inteForm.drawHitCount"
    }
  }, [_c('template', {
    staticStyle: {
      "line-height": "34px"
    },
    slot: "append"
  }, [_vm._v("次")])], 2) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "自动兑奖:",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1",
      "disabled": ""
    },
    model: {
      value: (_vm.inteForm.isAuto),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "isAuto", $$v)
      },
      expression: "inteForm.isAuto"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "inline",
    attrs: {
      "label": "0",
      "disabled": ""
    },
    model: {
      value: (_vm.inteForm.isAuto),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "isAuto", $$v)
      },
      expression: "inteForm.isAuto"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否无限:",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1",
      "disabled": ""
    },
    model: {
      value: (_vm.inteForm.isInfinite),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "isInfinite", $$v)
      },
      expression: "inteForm.isInfinite"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "inline",
    attrs: {
      "label": "0",
      "disabled": ""
    },
    model: {
      value: (_vm.inteForm.isInfinite),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "isInfinite", $$v)
      },
      expression: "inteForm.isInfinite"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "兑奖URL:",
      "prop": "prizeUrl",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "false",
      "disabled": ""
    },
    model: {
      value: (_vm.inteForm.definePrizeUrl),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "definePrizeUrl", $$v)
      },
      expression: "inteForm.definePrizeUrl"
    }
  }, [_vm._v("不跳转")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-radio', {
    staticClass: "inline",
    attrs: {
      "label": "true",
      "disabled": ""
    },
    model: {
      value: (_vm.inteForm.definePrizeUrl),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "definePrizeUrl", $$v)
      },
      expression: "inteForm.definePrizeUrl"
    }
  }, [_vm._v("自定义URL")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.inteForm.definePrizeUrl == "true") ? _c('el-input', {
    staticClass: "inputTitle",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.inteForm.prizeUrl),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "prizeUrl", $$v)
      },
      expression: "inteForm.prizeUrl"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "prizeContent",
    attrs: {
      "label": "广告曝光代码:"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5
      },
      "disabled": ""
    },
    model: {
      value: (_vm.inteForm.adExposingCodes),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "adExposingCodes", $$v)
      },
      expression: "inteForm.adExposingCodes"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "prizeContent",
    attrs: {
      "label": "文案类型：",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1",
      "disabled": ""
    },
    model: {
      value: (_vm.inteForm.isRedeem),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "isRedeem", $$v)
      },
      expression: "inteForm.isRedeem"
    }
  }, [_vm._v("兑奖码类型")]), _vm._v(" "), _c('el-radio', {
    staticClass: "inline",
    attrs: {
      "label": "0",
      "disabled": ""
    },
    model: {
      value: (_vm.inteForm.isRedeem),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "isRedeem", $$v)
      },
      expression: "inteForm.isRedeem"
    }
  }, [_vm._v("自定义文案")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "prizeContent",
    attrs: {
      "label": "文案:"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5
      },
      "disabled": ""
    },
    model: {
      value: (_vm.inteForm.defineText),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "defineText", $$v)
      },
      expression: "inteForm.defineText"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "time",
    attrs: {
      "prop": "startTime",
      "label": "兑换开始时间："
    }
  }, [_c('el-date-picker', {
    staticClass: "qizhiDate",
    attrs: {
      "format": "yyyy/MM/dd",
      "placeholder": "yyyy/MM/dd",
      "disabled": ""
    },
    model: {
      value: (_vm.inteForm.startTime),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "startTime", $$v)
      },
      expression: "inteForm.startTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "time",
    attrs: {
      "prop": "endTime",
      "label": "兑换结束时间："
    }
  }, [_c('el-date-picker', {
    staticClass: "qizhiDate",
    attrs: {
      "format": "yyyy/MM/dd",
      "placeholder": "yyyy/MM/dd",
      "disabled": ""
    },
    model: {
      value: (_vm.inteForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "endTime", $$v)
      },
      expression: "inteForm.endTime"
    }
  })], 1), _vm._v(" "), _c('select-school', {
    attrs: {
      "schObj": _vm.inteForm.schObj,
      "canUse": _vm.canUse
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "time",
    attrs: {
      "label": "替换开始时间：",
      "required": ""
    }
  }, [_c('el-date-picker', {
    staticClass: "qizhiDate",
    attrs: {
      "format": "yyyy/MM/dd",
      "placeholder": "yyyy/MM/dd",
      "disabled": ""
    },
    model: {
      value: (_vm.inteForm.replaceStartTime),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "replaceStartTime", $$v)
      },
      expression: "inteForm.replaceStartTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "time",
    attrs: {
      "label": "替换结束时间：",
      "required": ""
    }
  }, [_c('el-date-picker', {
    staticClass: "qizhiDate",
    attrs: {
      "format": "yyyy/MM/dd",
      "placeholder": "yyyy/MM/dd",
      "disabled": ""
    },
    model: {
      value: (_vm.inteForm.replaceEndTime),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "replaceEndTime", $$v)
      },
      expression: "inteForm.replaceEndTime"
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b649f3d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/integration/inteChangeDet.vue
// module id = 936
// module chunks = 0